var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{staticClass:"pa-0",attrs:{"disabled":_vm.disabled,"loading":_vm.batchLoading,"outlined":"","dense":"","value":_vm.value,"items":_vm.batches,"label":_vm.label || 'Select batch'},on:{"change":_vm.setBatch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }